export default __webpack_public_path__ + "static/media/linkedin.90379065.svg";